import '../../../../sass/base.scss';
import '../../../../sass/components/header/base_header.scss';
import '../../../../sass/components/utils.scss';
import '../mobile_card_styles';
import '../../../../sass/components/list/sfm_card.scss';
import '../../../../sass/pages/list/offered/offered.scss';
import '../../../../sass/components/message_box.scss';
import '../../../../sass/experiments/mobile_srp.scss';
import '../../../../sass/components/list/broaden.scss';
import '../../../components/case_study_banner/index.js';
import mountSearchTools from '../../../components/list/search_tools/mount';
import mountSearchFilters from '../../../components/list/search_filters/mount';
import {
  createImpression,
  bindClickEvent,
  trackImpressions,
} from '../../../components/list/click_tracking';
import triggerRegistrationPrompt from '../../../components/list/registration_prompt';
import triggerRegistrationPromptMobileList from '../../../components/list/registration_prompt_mobile_with_exp_list';
import bindSaveEvent from '../../../components/list/save_ads';
import formatCurrency from '../../../components/list/currency_formatting';
import bindFacebookLoginButtons from '../components/facebookLogin';
import saveSearchData from '../components/saveSearchData';
import '../../../experiments/offered_ad_promo_banner/experiment';
import srp_promo from '../components/srp_promo';

const mountElement = document.querySelector('#searchTools');
if (mountElement) {
  mountSearchTools(mountElement);
}

const mountFiltersElement = document.querySelector('#searchFilters');
if (mountFiltersElement) {
  mountSearchFilters(mountFiltersElement);
}

if (window._sr && window.dataLayer) {
  const results = document.querySelectorAll('.listing-result');
  results.forEach((result) => {
    if (
      result.classList.contains('listing_sfm') ||
      result.classList.contains('promo-offered-ad-banner')
    ) {
      return;
    }
    // Might make more sense to pass the dataset through to createImpressions, this would further remove any reliance of browser apis.
    createImpression(result);
    bindClickEvent(result);
    bindSaveEvent(result);
  });
  trackImpressions(window._sr.ecommerce);
}

formatCurrency();
bindFacebookLoginButtons();
if (window._sr.site.mobile) {
  triggerRegistrationPromptMobileList();
} else {
  triggerRegistrationPrompt();
}

saveSearchData();
srp_promo();
